import { createSlice } from "@reduxjs/toolkit";

const estadodecuentasState = {
  dataestadodecuentas: {},
}

export const estadodecuentasSlice = createSlice({
  name: "estadodecuentas",
  initialState: estadodecuentasState,
  reducers: {
    GuardarEstadoDeCuentasData: (state, actions) => {
      state.dataestadodecuentas = actions.payload;
    },
    EliminarEstadoDeCuentasData: () => estadodecuentasState,
  }
});

export const { GuardarEstadoDeCuentasData, EliminarEstadoDeCuentasData } = estadodecuentasSlice.actions;

export default estadodecuentasSlice.reducer;